<!--
    描述：公共考核页
    时间：2021-07-07
    Created by 王帅
-->
<template>
    <div class="mark-layout">
        <div class="info-nav">
            <span
                >工程项目名称：<i class="color-blue">{{ objName }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span
                >项目类型：<i class="color-blue">{{ proTypeName }}</i></span
            >
        </div>
        <div class="info-nav mb10">
            <span
                >考核类型：<i class="color-blue">{{ markObjName }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span
                >申报人：<i class="color-blue">{{ bejudger && bejudger !== '' ? bejudger : userInfo.sname }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span
                >申报单位：<i class="color-blue">{{ companyName }}</i></span
            >
            <el-divider class="divider" direction="vertical"></el-divider>
            <span class="is-required-item" v-if="mode !== 'view' && mode !== 'check'"
                >考核单位：
                <el-select v-model="selectUnit" size="small">
                    <el-option
                        v-for="(item, index) in assessList"
                        :key="item.id"
                        :value="item.id"
                        :label="item.sname"
                    ></el-option>
                </el-select>
            </span>
            <span v-else>考核单位：<i class="color-blue">{{ showUnitName }}</i></span>

            <!-- <span>合计单项满分值: {{  }}</span> -->
        </div>
        <!-- 选择列表 -->
        <vxe-table
            ref="tableObj"
            :data="tableObj.tableData"
            :loading="tableObj.loading"
            :border="tableObj.border"
            :resizable="tableObj.resizable"
            :size="tableObj.size"
            :height="tableObj.height"
            highlight-current-row
            highlight-hover-row
            auto-resize
            show-overflow="tooltip"
            show-header-overflow="tooltip"
            :span-method="mergeRowMethod"
        >
            <vxe-table-column
                type="seq"
                title="序号"
                width="60"
                align="center"
            ></vxe-table-column>
            <vxe-table-column
                v-for="(item, index) in activeColumns"
                :key="item.prop + index"
                :field="item.prop"
                :title="item.title"
                :min-width="item.minWidth"
                :width="item.width"
                :align="item.align"
                :header-align="item.headerAlign"
                :edit-render="item.editRender"
            >
                <template v-slot="{ row }">
                    <!-- 如果需要渲染 -->
                    <span v-if="item.needRender">{{
                        item.function(row[item.prop])
                    }}</span>

                    <!-- 如果是 评分 -->
                    <!-- <vxe-input
                        v-else-if="item.prop === 'score'"
                        type="number"
                        :disabled="tableObj.showMode"
                        v-model.number="row.score"
                        :max="row.singleScore"
                        digits="1"
                        step="0.5"
                        min="0"
                    ></vxe-input> -->

                    <!-- 申报分值 -->
                    <el-input-number
                        v-else-if="item.prop === 'declareScore'"
                        v-model.number="row.declareScore"
                        size="small"
                        class="score-input"
                        :disabled="mode === 'view' || mode === 'check'"
                        controls-position="right"
                        :max="row.singleScore"
                        :min="0"
                        :step="0.5"
                        step-strictly
                    ></el-input-number>
                    
                    <!-- 考核分值 -->
                    <el-input-number
                        v-else-if="item.prop === 'assessScore'"
                        v-model.number="row.assessScore"
                        size="small"
                        class="score-input"
                        :disabled="isDisabled"
                        controls-position="right"
                        :max="row.singleScore"
                        :min="0"
                        :step="0.5"
                        step-strictly
                    ></el-input-number>

                    <!-- 如果是 评语 -->
                    <vxe-input
                        v-else-if="item.prop === 'comment'"
                        :disabled="isDisabled"
                        v-model="row.comment"
                        maxlength="50"
                        show-word-count
                        placeholder="请输入评语，不超过50个字"
                    ></vxe-input>

                    <span v-else>{{ row[item.prop] }}</span>
                </template>
            </vxe-table-column>
        </vxe-table>

        <div class="setting-text"
             v-if="mode !== 'edit'">
            <template v-if="mode !== 'check' && this.status !== 2">
                <p class="show-total pdt10">总分： {{ totalScore }}分
                </p>
                <p>申报分值：<span class="text-border color-blue">{{ sumTotal }}分</span></p>
                <!-- <p>{{ resultInfo }}</p> -->
            </template>
            <template v-if="mode === 'check' || this.status === 2">
                <p class="show-total pdt10">总分： {{ totalScore }}分</p>
                <p>
                    <span>申报分值：<span class="text-border color-blue">{{ sumTotal }}分</span></span>
                    <span class="ml20">考核分值：<span class="text-border color-blue">{{ sumCheckTotal }}分</span></span>
                    <span class="ml20">考核结果：<span class="text-border color-blue">{{ resultCheckText }}</span></span>
                </p>
                <!-- <p>{{ resultInfo }}</p> -->
            </template>
        </div>
        <!-- <el-row class="mt20 setting-text">
            <el-col :span="20">
                <p class="show-total">总分： {{ totalScore }}分</p>
                <p>
                    合计评分：<span class="text-border color-blue">{{ sumTotal }}分</span>
                    评分结果：<span class="text-border color-blue">{{ resultText }}</span>
                </p>
                <p>{{ resultInfo }}</p>
            </el-col>
            <el-col :span="4" class="text-right">
                <el-button class="btn-blue" @click="onSaveRecords" :loading="btnLoading"
                    >提交</el-button
                >
            </el-col>
        </el-row> -->
    </div>
</template>

<script>
import * as Api from "api/evaluateManage/DailyEvaluate.js";
import { $deepCopy } from "utils/tools.js";
import { mapState } from "vuex";
export default {
    props: {
        // 模式 新增 还是 编辑
        mode: {
            type: String,
            default: "add",
        },
        // 当前状态
        status: {
            type: Number,
            default: 0
        },
        // 工程项目名称
        objName: {
            type: String,
            default: "",
        },
        // 项目类型名称
        proTypeName: {
            type: String,
            default: "",
        },
        // 考核人主体类型
        judgeRole: {
            type: String,
            default: "1013002",
        },
        // 被考核人主体类型
        beJudgeRole: {
            type: String,
            default: "1013003",
        },
        // 考核类型
        markObj: {
            type: String,
            default: "1015001",
        },
        // 考核类型中文
        markObjName: {
            type: String,
            default: "",
        },
        // 申报人
        bejudger: {
            type: String,
            default: "",
        },
        // 申报单位
        beUnitName: {
            type: String,
            default: "",
        },
        // 适用业务(审计系统码表写死)
        applyBus: {
            type: String,
            default: "1016001",
        },
    },
    data() {
        return {
            tableObj: {
                tableData: [],
                loading: false,
                border: true,
                resizable: true,
                size: "small",
                height: "",
                setting: false, // 开始设置
                showMode: false, // 展示模式
                viewMode: false,
                canSave: false, // 可以保存
            },
            // 返回的业务参数
            totalScore: 0,
            markResult: [
                {
                    type: 0, // 0.差评 1.良好 2.优秀 3.完美
                    min: 0,
                    max: 60,
                    title: "差评",
                },
                {
                    type: 1, // 0.差评 1.良好 2.优秀 3.完美
                    min: 61,
                    max: 80,
                    title: "良好",
                },
                {
                    type: 2, // 0.差评 1.良好 2.优秀 3.完美
                    min: 81,
                    max: 95,
                    title: "优秀",
                },
                {
                    type: 3, // 0.差评 1.良好 2.优秀 3.完美
                    min: 96,
                    max: 100,
                    title: "完美",
                },
            ],
            btnLoading: false,
            assessList: [],
            selectUnit: "",
            showUnitName: '',   // 要展示的 考核单位名称
            declareTotal: 0,    // 申报总分
        };
    },
    created() {
        // 获取考核单位
        this.getAssessList();
    },
    methods: {
        // 通用行合并函数（将相同多列数据合并为一行）
        mergeRowMethod({ row, _rowIndex, column, visibleData }) {
            // 定义要合并的 列 属性数组
            const fields = ["typeName"];
            const compareField = "itemType";
            const typeValue = row[compareField];
            // 如果是 合并的那列 且 要比较的值有数据
            if (typeValue && fields.includes(column.property)) {
                // 上一行
                const prevRow = visibleData[_rowIndex - 1];
                // 下一行
                let nextRow = visibleData[_rowIndex + 1];

                // 如果上一行存在 且 数据和当前行相同
                if (prevRow && prevRow[compareField] === typeValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[compareField] === typeValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        },

        // 点击提交
        saveJudge() {
            // 申报
            let _score = ''
            let _sum = ''
            if (this.mode !== 'check') {
                _score = 'declareScore'
                _sum = this.sumTotal
            } else {
                _score = 'assessScore'
                _sum = this.sumCheckTotal
            }

            // 判断
            let _null = this.tableObj.tableData.find(
                (x) => x[_score] === undefined || x[_score] === ""
            );

            // 为空判断
            if (_sum === "" || _null) {
                this.$message.warning("请给出评分后提交！");
                return false;
            }

            // 合计判断
            if (this.sumTotal > this.totalScore) {
                this.$message.warning("合计评分 大于总分值，请重新输入！");
                return false;
            }

            return true
        },

        // 获取考核单位
        getAssessList() {
            Api.getAssessList({})
                .then((res) => {
                    this.assessList = res.data;
                })
                .catch((err) => {});
        },
    },
    computed: {
        ...mapState("user", {
            userInfo: (state) => state.userInfo,
        }),

        // 当前模式 查看 还是 评价
        isDisabled() {
            return this.status === 2 || this.mode === 'view';
        },

        // 表格列
        activeColumns() {
            let columns = [
                {
                    prop: "typeName",
                    title: "类别",
                    minWidth: 0,
                    width: 120,
                    headerAlign: "center",
                    align: "center",
                    // editRender: { name: "input", attrs: { type: "text" } },
                },
                {
                    prop: "sname",
                    title: "名称",
                    minWidth: 120,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "content",
                    title: "内容",
                    minWidth: 220,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "standard",
                    title: "考核标准",
                    minWidth: 250,
                    width: 0,
                    headerAlign: "center",
                    align: "left",
                },
                {
                    prop: "singleScore",
                    title: "单项满分值",
                    minWidth: 120,
                    width: 120,
                    headerAlign: "center",
                    align: "right",
                    // editRender: { name: "input", attrs: { type: "text" } },
                },
                {
                    prop: "declareScore",
                    title: "受托单位申报分值",
                    minWidth: 140,
                    width: 140,
                    headerAlign: "center",
                    align: "right",
                    // editRender: { name: "input", attrs: { type: "text" } },
                }
            ];

            if (this.mode === 'check' || this.status === 2) {
                columns.push({
                    prop: "assessScore",
                    title: "审计机关考核分值",
                    minWidth: 0,
                    width: 140,
                    headerAlign: "center",
                    align: "right",
                })
                columns.push({
                    prop: "comment",
                    title: "考核评语",
                    minWidth: 200,
                    width: 0,
                    headerAlign: "center",
                    align: "right",
                })
            }

            return columns;
        },

        // 最终评分结果
        resultText() {
            let str = "";
            this.markResult.map((x, index) => {
                if (
                    parseFloat(this.sumTotal) >= parseFloat(x.min) &&
                    parseFloat(this.sumTotal) <= parseFloat(x.max)
                ) {
                    str = x.title;
                }

                if (parseFloat(this.sumTotal) <= parseFloat(x.min) && parseFloat(this.sumTotal) > parseFloat(this.markResult[index - 1].max)) {
                    console.log(x)
                    str = x.title
                }
            });
            return str;
        },

        // 评分结果 提示文案
        resultInfo() {
            let str = "提示：评分结果 ";
            this.markResult.map((x) => {
                str = str + `${x.min}-${x.max}分 为${x.title}, `;
            });
            str = str.slice(0, str.length - 2);
            return str;
        },

        // 输入的分数合计
        sumTotal() {
            let arr = this.tableObj.tableData.map((x) => parseFloat(x.declareScore));
            return arr.sum();
        },

        // 考核分值合计
        sumCheckTotal() {
            let arr = this.tableObj.tableData.map((x) => parseFloat(x.assessScore));
            return arr.sum();
        },

        // 考核分值最终结果
        resultCheckText() {
            let str = "";
            this.markResult.map((x, index) => {
                if (
                    Math.ceil(this.sumCheckTotal) >= parseFloat(x.min) &&
                    Math.ceil(this.sumCheckTotal) <= parseFloat(x.max)
                ) {
                    str = x.title;
                }
            });
            return str;
        },

        // 申报单位
        companyName() {
            return this.beUnitName && this.beUnitName !== '' ? this.beUnitName : this.$getSessionItem("companyName");
        },

        // 考核单位
        unitName() {
            let _item = this.assessList.find(x => x.id === this.selectUnit)
            return _item ? _item.sname : ''
        }
    },
};
</script>

<style scoped lang="less">
.mark-layout {
    height: 100%;
    background-color: #fff;
    padding: 0 20px 10px;
    overflow-y: auto;

    .color-blue {
        color: #256fc8;
        font-style: normal;
    }

    .info-nav {
        line-height: 40px;
        color: #202020;
        font-size: 14px;
        // border-bottom: 1px solid #2671cc;

        .info-title {
            font-size: 16px;
            margin-right: 20px;
        }

        .divider {
            background-color: #202020;
            vertical-align: text-top;
        }
    }

    .is-required-item {
        display: inline-flex;
    }

    .min-height {
        min-height: 500px;
    }

    .text-border {
        margin-right: 10px;
        border-bottom: 1px solid #666;
        font-size: 14px;
    }

    .setting-text {
        line-height: 35px;
        font-size: 14px;
    }

    .score-input {
        width: 100%;
        /deep/ .el-input__inner {
            padding: 0 40px 0 10px !important;
            text-align: left;
        }
    }
}
</style>

<style>
.vxe-table--tooltip-wrapper {
    z-index: 3000 !important;
}
</style>